module.exports = __webpack_public_path__ + "static/img/parking.962cae8f.png";